import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ModuleHeader from "../components/ModuleHeader";
import ReactEcharts from "echarts-for-react";
// 导入图标（按顺序对应：货位总数、使用中、闲置）
import FreightCount from "@/assets/img/mms/freight-count.png";
import FreightUsing from "@/assets/img/mms/freight-using.png";
import FreightIdle from "@/assets/img/mms/freight-idle.png";
const StorageUtilization = ({ className = "", }) => {
    const stats = [
        { icon: FreightCount, title: "货位总数", value: 1152 },
        { icon: FreightUsing, title: "使用中货位", value: 802 },
        { icon: FreightIdle, title: "闲置货位", value: 350 },
    ];
    // 折线图数据（适配垂直空间有限的场景）
    const lineData = {
        xAxis: ["1/03", "1/04", "1/05", "1/06", "1/07", "1/08", "1/09"],
        series: [
            {
                name: "使用中货位",
                data: [600, 650, 550, 400, 500, 600, 802],
                color: "#4A97F4",
            },
            {
                name: "闲置货位",
                data: [300, 350, 450, 500, 600, 700, 350],
                color: "#62D7A5",
            },
        ],
    };
    // 折线图配置（重点优化紧凑布局适配）
    const getLineOption = () => {
        // 计算Y轴最大值和合适的间隔
        const allData = [...lineData.series[0].data, ...lineData.series[1].data];
        const maxValue = Math.max(...allData);
        const minValue = Math.min(...allData);
        // 自动计算合适的Y轴间隔
        const range = maxValue - minValue;
        let interval = 100;
        if (range <= 200) {
            interval = 50;
        }
        else if (range <= 500) {
            interval = 100;
        }
        else if (range <= 1000) {
            interval = 200;
        }
        else {
            interval = 500;
        }
        // 计算Y轴最大值（向上取整到间隔的倍数）
        const maxY = Math.ceil(maxValue / interval) * interval;
        const minY = Math.floor(minValue / interval) * interval;
        return {
            tooltip: {
                trigger: "axis",
                axisPointer: { type: "cross" },
                backgroundColor: "rgba(7, 31, 75, 0.8)",
                borderColor: "#446b9f",
                textStyle: { color: "#fff" },
            },
            legend: {
                icon: "circle",
                top: 0,
                right: "center",
                itemWidth: 10,
                itemHeight: 10,
                textStyle: { color: "#FFFFFF", fontSize: 12 },
                itemGap: 10,
            },
            grid: {
                left: 20, // 增加左侧间距给Y轴标签更多空间
                right: 30,
                bottom: 0,
                top: 32,
                containLabel: true,
            },
            xAxis: {
                type: "category",
                data: lineData.xAxis,
                axisLabel: {
                    color: "#FFFFFF",
                    fontSize: 11,
                },
                axisLine: { lineStyle: { color: "#44444480" } },
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: "#44444480",
                        type: "dashed",
                    },
                },
            },
            yAxis: {
                type: "value",
                name: "数量（项）",
                nameTextStyle: {
                    color: "#ffffff",
                    fontSize: 12,
                },
                min: minY, // 设置最小值
                max: maxY, // 设置最大值
                interval: interval, // 设置固定间隔
                axisLabel: {
                    color: "#FFFFFF",
                    fontSize: 11,
                    formatter: (value) => value >= 1000 ? `${value / 1000}k` : value, // 数值单位简化
                },
                axisLine: {
                    show: true, // 显示Y轴线
                    lineStyle: { color: "#44444480" },
                },
                splitLine: {
                    lineStyle: {
                        color: "#22222280",
                        type: "dashed",
                    },
                },
            },
            series: lineData.series.map((item) => ({
                ...item,
                type: "line",
                smooth: true,
                symbol: "circle",
                symbolSize: 5,
                itemStyle: { color: item.color },
                lineStyle: { color: item.color, width: 2 },
            })),
        };
    };
    return (_jsxs("div", { className: `
        flex flex-col min-h-0 relative
        bg-gradient-to-tr from-[#071F4A] to-[#0f295300]
        backdrop-blur-sm  ${className}
      `, children: [_jsx(ModuleHeader, { title: "\u8D27\u4F4D\u5229\u7528" }), _jsxs("div", { className: "flex-1 flex flex-col min-h-0", children: [_jsx("div", { className: " flex items-center justify-around pt-[0.1rem] pb-[0.1rem]", children: stats.map((item, idx) => (_jsxs("div", { className: "flex items-center space-x-[0.2rem]", children: [_jsx("img", { src: item.icon, alt: item.title, style: {
                                        width: "0.44rem",
                                        height: "0.56rem",
                                        maxWidth: "100%",
                                        maxHeight: "100%",
                                        objectFit: "contain",
                                    }, className: "object-contain" }), _jsxs("div", { className: "flex flex-col", children: [_jsx("div", { className: "text-[0.14rem] text-gray-300", children: item.title }), _jsx("div", { className: "text-[0.18rem] text-white font-bold", children: item.value.toLocaleString() })] })] }, idx))) }), _jsx("div", { className: "flex-1 min-h-0", children: _jsx(ReactEcharts, { option: getLineOption(), style: { width: "100%", height: "100%" }, opts: { renderer: "canvas" } }) })] })] }));
};
export default StorageUtilization;
